import { Get } from "../utils/api";
import { Product } from "../../types/api/Product";
import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

export default (orgId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();
  return useQuery<Product[]>(
    `products_${orgId}`,
    async () => {
      return await Get<Product[]>(
        `/api/product/organization/${orgId}/for-sale`,
        await getAccessTokenSilently()
      );
    },
    {
      retry: false,
      onError: () => {
        navigate(`/storefront/${orgId}/not-found`);
      },
    }
  );
};
